// extracted by mini-css-extract-plugin
export var baseMediaHolder = "FloatingStreamPlayer-module--baseMediaHolder--64d7e";
export var closeTop = "FloatingStreamPlayer-module--closeTop--2eb47";
export var customMediaControls = "FloatingStreamPlayer-module--customMediaControls--cf931";
export var eventLink = "FloatingStreamPlayer-module--eventLink--e3056";
export var icon = "FloatingStreamPlayer-module--icon--53240";
export var inside = "FloatingStreamPlayer-module--inside--13660";
export var mobileMediaWindow = "FloatingStreamPlayer-module--mobileMediaWindow--da7f8";
export var subtitleCountdown = "FloatingStreamPlayer-module--subtitleCountdown--01d1a";
export var subtitleText = "FloatingStreamPlayer-module--subtitleText--23db4";